
import { DisplayItems } from '../features/items/DisplayItems';
import {DisplayCart} from '../features/cart/DisplayCart'
import {LandingPage} from '../features/landingpage/LandingPage'
import {PageHeader} from "../components/PageHeader"
import { RouterProvider, createBrowserRouter, Route, createRoutesFromElements } from 'react-router-dom';
import { useParams } from 'react-router-dom/dist';


function App(props){
  const router = createBrowserRouter(
    createRoutesFromElements(
      
        <Route path='/' element={<PageHeader />}>
          <Route index element={<DisplayItems/>}/>
          <Route path='/cart' element={<DisplayCart/>}/>
          <Route path='/:item' element={<LandingPage/>}/>
        </Route>
      
    )
  )

  return (
    <RouterProvider router={router} />
  )
}

/*function App(props) {
  return (
    <div className="App">
      <DisplayItems items = {props.state.inventory} dispatch={props.dispatch}/>
      <DisplayCart cart = {props.state.cart} dispatch={props.dispatch}/>
      <LandingPage/>
    </div>
  );
}
*/
export default App;
